import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission (you can replace this with actual API call)
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      // Reset success message after 5 seconds
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }, 1000);
  };

  return (
    <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">

      <div className="mb-8">
        <Link to="/" className="mb-4 inline-block" style={{ color: 'var(--highlight)' }}>
          ← Back to Home
        </Link>
        <h1 className="text-3xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
          Contact Us
        </h1>
        <p className="" style={{ color: 'var(--text-secondary)' }}>
          Have a question, suggestion, or need help? We'd love to hear from you!
        </p>
      </div>

      <div className="">
        {/* Contact Information */}
        <div className="mb-8 p-6 rounded-lg" style={{ backgroundColor: 'var(--surface)', border: '1px solid var(--border)' }}>


          
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>Email</h3>
                <p className="text-sm" >
                  <a href="mailto:support@predictorpro.com" className="hover:underline" style={{ color: 'var(--highlight)' }}>
                    support@predictorpro.com
                  </a>
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>Discord</h3>
                <p className="text-sm opacity-70" style={{ color: 'var(--text-secondary)' }}>
                  Join our community server for real-time support
                </p>
                <a 
                  href="https://discord.gg/CNKjGUKzZJ" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm hover:underline mt-1 inline-block"
                  style={{ color: 'var(--highlight)' }}
                >
                  Join Discord Server →
                </a>
              </div>
            </div>


          </div>

{/*           <div className="mt-8 p-6 rounded-lg bg-gray-50 dark:bg-gray-800/50">
            <h3 className="font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>Common Questions</h3>
            <div className="space-y-2 text-sm">
              <p className="opacity-70" style={{ color: 'var(--text-secondary)' }}>
                • How do I join a league?
              </p>
              <p className="opacity-70" style={{ color: 'var(--text-secondary)' }}>
                • How does the scoring system work?
              </p>
              <p className="opacity-70" style={{ color: 'var(--text-secondary)' }}>
                • Can I create my own league?
              </p>
              <p className="opacity-70" style={{ color: 'var(--text-secondary)' }}>
                • How do I reset my password?
              </p>
            </div>
            <div className="mt-4">
              <Link 
                to="/help" 
                className="text-sm hover:underline"
                style={{ color: 'var(--highlight)' }}
              >
                View Help Center →
              </Link>
            </div>
          </div> */}
        </div>


      </div>
    </div>
  );
};

export default Contact; 